import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Link from 'next/link';
import ClusterMenu from 'components/common/ClusterMenu';
import { useSelector } from 'store';
import LocalStitchMap from 'components/common/LocalStitchMap';

var PlaceListService = function PlaceListService() {
  var branches = useSelector(function (state) {
    return state.space.branches;
  });
  var mapCenter = {
    lat: 37.555419,
    lng: 126.970801
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ClusterMenu, {
      selected: branches.region
    }), /*#__PURE__*/_jsxs("div", {
      className: "cnts-wrap",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "stit",
        children: "Local Stitch Branch"
      }), /*#__PURE__*/_jsxs("div", {
        className: "retail-list",
        children: [/*#__PURE__*/_jsx("div", {
          className: "list-wrap",
          children: /*#__PURE__*/_jsx("ul", {
            className: "branch-type",
            children: branches.results && branches.results.map(function (branch) {
              var href = "/branch/place/".concat(branch.id);
              return /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: href,
                  children: /*#__PURE__*/_jsxs("a", {
                    children: [/*#__PURE__*/_jsxs("div", {
                      className: "info",
                      children: [/*#__PURE__*/_jsx("strong", {
                        children: branch.name
                      }), /*#__PURE__*/_jsx("address", {
                        children: branch.address
                      })]
                    }), /*#__PURE__*/_jsx("span", {
                      className: "thumb",
                      children: /*#__PURE__*/_jsx("img", {
                        src: branch.representation_image,
                        alt: ""
                      })
                    })]
                  })
                })
              }, branch.id);
            })
          })
        }), /*#__PURE__*/_jsx(LocalStitchMap, {
          center: mapCenter,
          branches: branches.results,
          zoom: 12
        })]
      })]
    })]
  });
};

export default PlaceListService;